module.exports = __webpack_public_path__ + "img/SI.ac434241.png";